// removed by extract-text-webpack-plugin
module.exports = {"nf-pdmi-form":"nf-pdmi-form","nf-pdmi-form__button":"nf-pdmi-form__button","nf-pdmi-form__label-input-pair":"nf-pdmi-form__label-input-pair","nf-pdmi-form__label":"nf-pdmi-form__label","nf-pdmi-form__required":"nf-pdmi-form__required","nf-pdmi-form__error":"nf-pdmi-form__error","nf-button":"nf-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/PdmiForm/PdmiForm.scss
// module id = 5830
// module chunks = 1